module.exports = __webpack_public_path__ + "img/top_lightning.17ed5bc9.png";